import { ISectionDatWithFlag } from "../../slot-selection.types";

export type ModalSlotConfirmationProps = {
  isOpen: boolean;
  sections: ISectionDatWithFlag[];
  onClose: () => void;
  onFinish: () => void;
};

export type IUseModalSlotConfirmation = {
  handleSubmit: () => void;
  loading: boolean;
};

export enum ISlotType {
  ALL = "all",
  MANDATORY = "mandatory",
  EXTRA = "extra"
}
